import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "invalid-feedback" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { "data-label": "hari" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "container-btn-action" }

import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
import { Form, Field } from 'vee-validate'
import vSelect from 'vue-select'
import * as Yup from 'yup'
import { useStore } from 'vuex'
import InputSwitch from 'primevue/inputswitch'
import { onMounted, getCurrentInstance, ref, computed } from 'vue'
import apiUseCase from '@/usecase/apiUseCase'
import { isNull } from 'lodash'
import rgxExp from '@/utils/helpers/regExp'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'

const moduleStore = 'hjpTable'
const endpoint = '/talent/v1/documentTypes'

export default /*@__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const store = useStore()
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const dataForm = ref()
const idPrams = computed(() => store.state[moduleStore].modal?.data?.id)

const initialValues = {
  Name: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.name : '',
  Description: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.description : '',
  Notification: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.reminderDaysBeforeExpiry : '',
  IsActive: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.IsActive : true
}

const schema = Yup.object().shape({
  Name: Yup.string()
    .required('Nama Dokumen harus diisi!')
    .min(3, 'Nama Dokumen minimal 3 karakter')
    .max(50, 'Nama Dokumen tidak boleh melebihi 50 karakter')
    .matches(rgxExp.notPrefixSpace, 'Nama Dokumen tidak boleh hanya menggunakan spasi')
    .test('unique-name', 'Nama Dokumen sudah digunakan', async (val) => {
      // console.log('val', val)
      if (!val) return true
      try {
        if (val.length < 3) return true
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val,
          filterField: ['name']
        })}`)
        const filterResult = res.result.data.filter((x: any) => x.name === val)
        // console.log('filterResult', filterResult)
        if (idPrams.value) {
          return filterResult.length === 0 || val === initialValues.Name
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  // Notification: Yup.number()
  //   .max(3, 'Notifikasi maksimal 3 digit')
})

const onSubmit = (values: any) => {
  console.log('masukk submit', values)
  // eslint-disable-next-line no-use-before-define
  processSubmit(values)
}

const hideSidebar = () => {
  store.dispatch('setShowModal', false)
  store.dispatch('setTitleFormSidebar', null)
}

const changeOk = (val: any) => {
  console.log('valll', val)
}

const onSearchOption = (search: any, loading: any) => {
  console.log('search', search)
}

const onSelectedBank = (selected: any) => {
  console.log('selected', selected)
}

const processSubmit = async (val: any) => {
  store.dispatch('showLoading')
  console.log('val', val)

  if (isNull(store.state.hjpTable.modal.data)) {
    dataForm.value = {
      name: val.Name,
      reminderDaysBeforeExpiry: null,
      // IsActive: val.IsActive
    }
  } else {
    dataForm.value = {
      id: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.id : '',
      name: val.Name,
      reminderDaysBeforeExpiry: val.Notification,
      description: val.Description
      // IsActive: val.IsActive,
    }
  }
  const response = isNull(store.state.hjpTable.modal.data) ? await apiUseCase.postOrPut(endpoint, null, dataForm.value) : await apiUseCase.postOrPut(endpoint, store.state.hjpTable.modal.data.id, dataForm.value)
  console.log('response', response)
  if (!response.error) {
    $toast.add({
      severity: 'success',
      detail: isNull(store.state.hjpTable.modal.data) ? 'Data Berhasil Ditambahkan' : 'Data Berhasil Diubah',
      group: 'bc',
      closable: false,
      life: 3000
    })
  } else {
    $toast.add({
      severity: 'error',
      detail: isNull(store.state.hjpTable.modal.data) ? 'Data Gagal Ditambahkan' : 'Data Gagal Diubah',
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
  store.dispatch('setShowModal', false)
  store.dispatch('setReloadDataTable', true)
  store.dispatch('setTitleFormSidebar', null)
  store.dispatch('hideLoading')
}

onMounted(() => {
  console.log('store', store.state)
  let titleForm = 'Tambah'
  if (store.state.hjpTable.modal.data) {
    titleForm = 'Edit'
  }
  store.dispatch('setTitleFormSidebar', `${titleForm} Dokumen`)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Form), {
      onSubmit: onSubmit,
      "validation-schema": _unref(schema),
      "initial-values": initialValues,
      class: "form-container"
    }, {
      default: _withCtx(({ errors, setFieldValue, values, meta }) => [
        _createElementVNode("div", _hoisted_1, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "label-text required" }, "Nama Dokumen", -1)),
          _createVNode(_unref(Field), { name: "Name" }, {
            default: _withCtx(({ field }) => [
              _createVNode(_unref(InputText), _mergeProps(field, {
                modelValue: values.Name,
                "onUpdate:modelValue": ($event: any) => ((values.Name) = $event),
                class: `input-primary ${errors.Name ? 'input-invalid' : ''}`,
                placeholder: "Nama Dokumen",
                autocomplete: "off",
                maxlength: 50
              }), null, 16, ["modelValue", "onUpdate:modelValue", "class"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_2, _toDisplayString(errors.Name), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "label-text" }, "Notifikasi Pengingat", -1)),
          _createVNode(_unref(Field), { name: "Notification" }, {
            default: _withCtx(({ field }) => [
              _createElementVNode("label", _hoisted_4, [
                _createVNode(_unref(InputText), _mergeProps(field, {
                  modelValue: values.Notification,
                  "onUpdate:modelValue": ($event: any) => ((values.Notification) = $event),
                  class: `input-primary ${errors.Notification ? 'input-invalid' : ''}`,
                  placeholder: "Masukkan angka, tidak diisi = 0 ",
                  autocomplete: "off",
                  maxlength: 3
                }), null, 16, ["modelValue", "onUpdate:modelValue", "class"])
              ])
            ]),
            _: 2
          }, 1024)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "label-text" }, "Keterangan", -1)),
          _createVNode(_unref(Field), {
            name: "Description",
            as: "textarea",
            placeholder: "Tulis Keterangan",
            class: "input-primary"
          }, {
            default: _withCtx(({ field }) => [
              _createVNode(_unref(Textarea), _mergeProps(field, {
                modelValue: values.Description,
                "onUpdate:modelValue": ($event: any) => ((values.Description) = $event),
                id: "description",
                autocomplete: "nope",
                autoResize: true,
                ref: "addressRef",
                rows: "3"
              }), null, 16, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(Button), {
            class: "btn-back mr-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (hideSidebar()))
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("Kembali")
            ])),
            _: 1,
            __: [4]
          }),
          _createVNode(_unref(Button), {
            type: "submit",
            class: "btn-primary mr-1"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("Simpan")
            ])),
            _: 1,
            __: [5]
          })
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"])
  ]))
}
}

})